
import React from "react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";

const CTASection = () => {
  return (
    <section className="bg-black py-20 text-white">
      <div className="container">
        <div className="mx-auto max-w-3xl text-center">
          <h2 className="mb-6 text-3xl font-bold md:text-4xl">
            Join the Movement for Safer Communities
          </h2>
          <p className="mb-8 text-lg text-gray-200">
            Every report helps build a safer neighborhood. Sign up today and be part of the solution.
          </p>
          <div className="flex flex-col items-center justify-center gap-4 sm:flex-row">
            <Link to="/register">
              <Button className="w-full bg-okkio-orange px-8 py-6 text-lg font-semibold hover:bg-okkio-orange-600 sm:w-auto">
                Create Free Account
              </Button>
            </Link>
            <Link to="/login">
              <Button variant="outline" className="w-full border-white px-8 py-6 text-lg font-semibold text-white hover:bg-white/10 sm:w-auto">
                Log In
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default CTASection;
